import type { EntriesQueryVariables } from '#graphql-operations'

export async function fetchServerPage<T>(limit: number, offset: number = 0, variables: EntriesQueryVariables): Promise<{ rows: T[], count: number, nextOffset: number | undefined }> {
  const { data } = await useGraphqlQuery('Entries', { ...variables, limit, offset })
  const rows = (data.entries ?? []) as T[]
  const count = data.entryCount ?? 0
  const hasNextPage = offset + limit <= count
  return { rows, count, nextOffset: hasNextPage ? offset + limit : undefined }
}
